import React, { useState } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import Footer from "./footer";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";



function ContactUs() {



    const [newData, setNewData] = useState({ user_firstname: '', user_emailaddress: '', user_contact_us: '', user_message: '' })

    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};

        if (!newData.user_firstname.trim()) {
            newErrors.user_firstname = 'Name is required.';
        } else if (!/^[a-zA-Z\s]+$/.test(newData.user_firstname)) {
            newErrors.user_firstname = '*Name should only contain letters and spaces.';
        }

        if (!newData.user_emailaddress.trim()) {
            newErrors.user_emailaddress = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(newData.user_emailaddress)) {
            newErrors.user_emailaddress = 'Enter a valid email address.';
        }

        //   if (newData.user_contact_us && !/^\d{10}$/.test(newData.user_contact_us)) {
        //      newErrors.user_contact_us = 'Enter a valid 10-digit contact number.';
        //   }

        if (!newData.user_contact_us.trim()) {
            newErrors.user_contact_us = '*number is required.';
        } else if (!/^\d{10}$/.test(newData.user_contact_us)) {
            newErrors.user_contact_us = 'Enter a valid 10-digit contact number.';
        }

        if (!newData.user_message) {
            newErrors.user_message = 'This field required.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // No errors
    };

   const formPutPartenshipdeed = () => {
    if (validateForm()) {
        console.log("Button clicked!", newData);
        PartenerSheepDeedService.contactForm(newData)
            .then((data) => {
                console.log(data);
                
                // ✅ Show success alert
                alert("Form submitted successfully!");

                // Reset form including checkbox
                setNewData({
                    user_firstname: '',
                    user_emailaddress: '',
                    user_contact_us: '',
                    user_message: '',
                    
                });

                // Clear errors
                setErrors({});
            })
            .catch((error) => {
                console.log(error);
                // ✅ Show error alert
                alert("Something went wrong. Please try again.");
            });
    }





    };
    return (
        // aboutcompany
        <>






            <div className="about-company">
                <div className="space80"></div>
                <div className="hero-area10 ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="title title2  ">
                                    <div className="space80"></div>
                                    <h1 className="sk-text-color text-center">Contact Us</h1>
                                    <h1 className="sk-text-color text-center">Vedi Legal Advice Pvt. Ltd.</h1>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="space80"></div>



                <div className="contact-boxes">
                    <div className="container">

                        <div className="row align-items-center">
                            <div className="col-lg-4">
                                <div className="single-contact-box">
                                    <div className="contact-box-icon">
                                        <img src="assets/img/icons/contact-1.png" alt="" />
                                    </div>
                                    <div className="contact-box-content">
                                        <p className="font-f-3">CALL US</p>
                                        <a className="font-f-3 con-text" href="tel:+91 8370055955">+91 83700 55955</a><br />
                                        <a className="font-f-3 con-text" href="tel:+91 8370055255">+91 83700 55255</a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="single-contact-box">
                                    <div className="contact-box-icon">
                                        <img src="assets/img/icons/contact-2.png" alt="" />
                                    </div>
                                    <div className="contact-box-content">
                                        <p className="font-f-3">EMAIL US</p>
                                        <a className="font-f-3 con-text" href="mailto:accounts@Dm2Legal.com">accounts@Dm2Legal.com</a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="single-contact-box">
                                    <div className="contact-box-icon">
                                        <img src="assets/img/icons/contact-3.png" alt="" />
                                    </div>
                                    <div className="contact-box-content">
                                        <p className="font-f-3">HEAD OFFICE</p>
                                        <a className="font-f-3 con-text" href="#">10 Ashok Nagar, Airport Army Head Quarter, 452006, Indore. Madhya Pradesh</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="main-contact-form section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="heading2 mr50">
                                    <small className="heading-top inner-heading-top"><img src="assets/img/icons/hands.svg" alt="" />Contact Us</small>
                                    <h2 className="pd-text">Let’s Work Together</h2>
                                    <h3>Vedi Legal Advice Pvt. Ltd.</h3>
                                    <p>
                                        Share your vision for your next projects with us now. Please
                                        contact us for basic questions. we’re here to help!
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="main-form">
                                    <form onSubmit={(e) => {
                                        e.preventDefault(); // Prevent the page from reloading
                                        formPutPartenshipdeed(); // Call your submission function
                                    }}>
                                        <div className="row">
                                            <div className="col-lg-12">{errors.user_firstname && <p className="error-text">{errors.user_firstname}</p>}
                                                <input type="text" name="user_name" placeholder="Name" value={newData.user_firstname} onChange={(e) => setNewData({ ...newData, user_firstname: e.target.value })} />
                                            </div>

                                            <div className="col-lg-12">{errors.user_emailaddress && <p className="error-text">{errors.user_emailaddress}</p>}
                                                <input type="email" name="email" placeholder="Email Address" value={newData.user_emailaddress} onChange={(e) => setNewData({ ...newData, user_emailaddress: e.target.value })} />
                                            </div>
                                            <div className="col-lg-12">{errors.user_contact_us && <p className="error-text">{errors.user_contact_us}</p>}
                                                <input type="number" name="number" placeholder="Contact Number" value={newData.user_contact_us} onChange={(e) => setNewData({ ...newData, user_contact_us: e.target.value })} />
                                            </div>

                                            <div className="col-12">
                                                {errors.user_message && <p className="error-text">{errors.user_message}</p>}
                                                <div className="niceSelect">
                                                    <select className="wide" onChange={(e) => setNewData({ ...newData, user_message: e.target.value })} value={newData.user_message}>
                                                        <option className="formop" data-display="Related to">Related to</option>
                                                        <option value="Lawyer">Lawyer</option>
                                                        <option value="Chartered Accountant">Chartered Accountant</option>
                                                        <option value="Company Secretary">Company Secretary</option>
                                                        <option value="Not sure">Not sure</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-12" style={{ marginTop: '24px' }}>
                                                <label className="consent-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        checked={newData.user_consent || false}
                                                        onChange={(e) =>
                                                            setNewData({ ...newData, user_consent: e.target.checked })
                                                        }
                                                        required
                                                    />

                                                    <span className="consent-text">
                                                        I hereby authorize to send me notifications via SMS, RCS Messages,
                                                        WhatsApp, Email, including Promotional, Transactional, and Informational
                                                        messages related to my interactions, orders, and service requests.
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="space20"></div>
                                            <div className="col-12">
                                                <button type="submit" className="full-btn theme-btn-3">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                        <div className="space80"></div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="title title2  ">

                                    {/* <h2 className="pd-text text-center">Connect with us</h2> */}
                                    <div className="space20"></div>
                                </div>
                            </div>

                        </div>

                        <div className="row box-center d-none">
                            <div className="col-lg-2 social-icon">
                                <img src="assets/img/Socialicons/fb.png" className="socialicon-1" />
                            </div>
                            <div className="col-lg-2 social-icon">
                                <img src="assets/img/Socialicons/insta.png" className="socialicon-1" />
                            </div>
                            <div className="col-lg-2 social-icon">
                                <a href="#" target="_blank"><img src="assets/img/Socialicons/linkedin.png" className="socialicon-1" /></a>
                            </div>
                            <div className="col-lg-2 social-icon">
                                <a href="#" target="_blank"><img src="assets/img/Socialicons/twitter.png" className="socialicon-1" /></a>
                            </div>

                            <div className="col-lg-12">
                                <div className="title title2  ">
                                    <div className="space20"></div>
                                    <h4 className="pd-text text-center">We are giving free tips on social media</h4>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>




            </div>

            <WhatsAppScrollButton />

            <Footer />

            <CircularScrollProgress />




        </>
    );
}

export default ContactUs;